var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-countown"},[(!_vm.isStarted)?_c('span',[_vm._v(" "+_vm._s(_vm.days)+"d : "+_vm._s(_vm.hours)+"h : "+_vm._s(_vm.minutes)+"m : "+_vm._s(_vm.seconds)+"s ")]):_c('span',[_vm._v(" VAI COMEÇAR EM BREVE! ")])])}
var staticRenderFns = []

export { render, staticRenderFns }